import apis from '@/apis';
import validateErp, { validateErpIsRepeat, validatePin } from './validate-erp';
import { getBytesLength } from '@/common/utils/helper';
import { message } from '@drip/drip-design';
export default {
  validateErp,
  validateErpIsRepeat,
  validatePin,
  getValidateNumberMaxThanZero,
  validateInt,
  getValidateNumberMax,
  validateActivityName,
  validatePlanCode,
  getValidateIsPositiveInt,
};

// 验证是否是正整数
function getValidateIsPositiveInt(msg) {
  return async (rule, value) => {
    if (!value) return;
    if (isNaN(value)) throw new Error(msg);
    value = Number(value);
    // 非正数
    if (value <= 0) throw new Error(msg);
    // 非整数
    if (value % 1 !== 0) throw new Error(msg);
  };
}

function getValidateNumberMaxThanZero(msg) {
  // 这里不做非空校验
  return async (rule, value) => {
    if (!value) return Promise.resolve();
    value = Number(value);
    if (isNaN(value)) throw new Error('请输入数字');
    if (value <= 0) throw new Error(msg);
  };
}

async function validateInt(rule, value) {
  value = value + '';
  if (value.indexOf('.') !== -1) throw new Error('请输入整数');
}

export function getValidateNumberMax(msg, max) {
  return async function validateMaxNumber(rule, value) {
    if (value > max) throw new Error(msg.replace('max', max));
  };
}

export async function validateActivityName(rule, value) {
  const res = await apis.checkActivityName(value);
  // 如果网络错误错误信息为空
  if (!res) throw new Error(' ');
  if (res.ret === '0') {
    if (res.data && res.data.has === 0) throw new Error(value + '已存在');
  } else {
    throw new Error('稍后重试');
  }
}

// 校验有效的活动ID
export async function validatePlanCode(rule, planCode, errorMsg) {
  if (!planCode) return; // 不判空
  const res = await apis.fetchActivityDetail({ planCode });
  // 如果网络错误错误信息为空
  if (!res) {
    message.error('稍后重试');
    throw new Error('');
  }
  if (res.ret !== '0') throw new Error(errorMsg || res.msg);
}

// 校验字符长度
export function validateBytesLength(props) {
  const { max, min, msg, value = '' } = props;
  return new Promise((resolve, reject) => {
    const length = getBytesLength(value);
    if (length < min || length > max) {
      return reject(new Error(msg));
    }
    return resolve();
  });
}
